import React, { Component } from 'react'
import Switch from 'react-switch';
import { Redirect } from 'react-router-dom'
import Config from '../../commons/config/Config.js';
import 'bootstrap4-duallistbox'
import 'bootstrap4-duallistbox/dist/bootstrap-duallistbox.css'
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Loading from '../ui/Loading.js'
import 'react-select/dist/react-select.css'
import moment from 'moment'
import 'moment/min/locales'
import Security from '../../commons/security/Security.js'
import { FormattedMessage, injectIntl } from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import swal2 from 'sweetalert2'

class TransportadorasAbm extends Component {
  constructor(props) {
    super(props);
    this.ajaxHandler = new AjaxHandler();

    moment.locale('es');

    this.state = {
      redirectTo: null,
      props: this.props,
      formData: {
        id: 0,
        nombre: '',
        centro_costo: null,
        activa: false,
      },
      centrosCostos: [],
      errors: [],
      loading: false
    };

    this.handleEstadoChange = this.handleEstadoChange.bind(this);
    this.handleNotificacionesActivasChange = this.handleNotificacionesActivasChange.bind(this);
    this.handleInputFormChange = this.handleInputFormChange.bind(this);
    this.handleSelectFormChange = this.handleSelectFormChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.formValidation = new FormValidation({
      component: this,
      validators: {
        'formData.nombre': (value) => Validator.notEmpty(value)

      }
    });

  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
  }
  componentDidMount() {
    if ((Security.hasPermission('TRANSPORTADORA_CREAR') && this.state.props.action === 'ADD') ||
      (Security.hasPermission('TRANSPORTADORA_MODIFICAR') && this.state.props.action === 'EDIT') ||
      (Security.hasPermission('TRANSPORTADORA_VISUALIZAR') && this.state.props.action === 'VIEW')) {
      this.ajaxHandler.subscribe(this);
      this.initForm();
    } else {
      this.setState({
        redirectTo: '/error'
      });
    }
  }
  initForm() {

    this.setState({ loading: true });
    let component = this;

    Promise.all([
      this.state.props.action !== 'ADD' ? this.ajaxHandler.getJson('/transportadoras/' + this.state.props.match.params.id) : null,
      this.ajaxHandler.getJson('/centros-costos')
    ]).then((data) => {
      let transportadora = data[0];
      let centrosCostos = data[1] || [];
      let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      if (transportadora) {
        formDataCopy['id'] = transportadora.id;
        formDataCopy['nombre'] = transportadora.nombre;
        formDataCopy['centro_costo'] = transportadora.centro_costo || null;
        formDataCopy['activa'] = typeof transportadora.activa !== 'undefined' ? transportadora.activa : false;
      }
      component.setState({
        formData: formDataCopy,
        centrosCostos: centrosCostos
      });

    }).catch(function (error) {
      console.log(error);
      component.exit();
    }).finally(() => {
      this.setState({ loading: false });
    });

  }

  getData(service, param) {
    let serviceURL = param ? (Config.get('apiUrlBase') + '/' + service + '/' + param) : (Config.get('apiUrlBase') + '/' + service);
    return fetch(serviceURL, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem("token")
      }
    })
      .then(response => {
        return AjaxHandler.handleResponseErrorsIsValid(response) ? response.json() : null;
      });
  }

  handleEstadoChange(activo) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy['activo'] = activo;
    this.setState({
      formData: formDataCopy
    });
  }

  handleNotificacionesActivasChange(notificacionesActivas) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy.usuario['notificacionesActivas'] = notificacionesActivas;
    this.setState({
      formData: formDataCopy
    });
  }

  handleInputFormChange(event) {
    const target = event.target;
    const name = target.name;
    let value;
    if (target.type === 'checkbox') {
      value = target.checked;
    } else if (target.type === 'radio') {
      value = target.value === 'true';
    } else {
      value = target.value;
    }

    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy[name] = value;
    this.setState({
      formData: formDataCopy
    });
  }

  handleSelectFormChange(name, object) {
    const value = object === null ? null : object.id;

    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy[name] = value;
    this.setState({
      formData: formDataCopy
    });
  }

  handlePaisChange(name, object) {
    this.handleSelectFormChange(name, object);
  }

  handleAddDetail(detail) {
    let ajaxHandler = this.ajaxHandler;
    swal2.fire({
      title: this.props.intl.formatMessage({ id: `transportadorasAbm.modal_add_${detail}.nombre`, defaultMessage: `Ingrese el nombre de ${detail}` }),
      input: 'text',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return this.props.intl.formatMessage({ id: `transportadorasAbm.modal_add_${detail}.errors_no_puede_estar_vacio_el_nombre`, defaultMessage: `No puede estar vacío el nombre` });
        }
      }
    }).then((result) => {
      if (result.value) {
        ajaxHandler.fetch('/transportadoras-detail/' + detail, {
          method: 'POST',
          body: JSON.stringify({
            nombre: result.value
          }),
        }).then(response => response.json()
          .then(dataDetail => {
            let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
            formDataCopy[detail] = dataDetail ? dataDetail.id : null;
            this.setState({
              formData: formDataCopy,
            });
          })).catch((error) => {
            let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
            formDataCopy[detail] = null;
            this.setState({
              formData: formDataCopy
            });
          })
      }
    })
  }

  handleSubmit(event) {
    this.setState({ loading: true });
    let component = this
    const centroCostoId = this.state.formData.centro_costo && this.state.formData.centro_costo.id ? this.state.formData.centro_costo.id : null;
    this.ajaxHandler.fetch('/transportadoras' + (this.props.action === 'ADD' ? '' : '/' + this.state.formData.id), {
      method: this.props.action === 'ADD' ? 'POST' : 'PUT',
      body: JSON.stringify({
        nombre: this.state.formData.nombre,
        centro_costo_id: centroCostoId,
        activa: this.state.formData.activa
      }),
    }).then(response => {
      if (response.status !== 400) {

        component.exit();
      } else {
        response.json()
          .then(data => {
            this.setState({
              errors: typeof data.detalle === 'string' ? [data.detalle] : data.detalle
            });
          });
      }
      window.scrollTo(0, 0);
    }).catch((error) => {
      component.ajaxHandler.handleError(error);
    }).finally(() => {
      this.setState({ loading: false });
    });
    event.preventDefault();

  }

  handleCancel(event) {
    this.exit();
  }

  exit() {
    this.setState({
      redirectTo: '/transportadoras'
    });
  }

  render() {
    this.formValidation.validate();
    let formData = this.state.formData;
    let validationState = this.formValidation.state;

    return (
      <React.Fragment>
        {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
        {this.state.loading && <Loading />}
        <div className="row">
          <div className="col-md-12">
            <div className="alert alert-danger" role="alert" hidden={this.state.errors.length === 0}>
              {this.state.errors.map((e, i) => <li key={i}><FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings['errors.default'])} /></li>)}
            </div>
            <form className="form form-horizontal" ref="form" onSubmit={this.handleSubmit}>
              <div className="form-body">
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section">
                        <i className="icon-home"></i><FormattedMessage id="transportadoraAbm.datos_generales" defaultMessage=" Datos Generales " /><div className="float-right" style={{ fontSize: '14px' }}><FormattedMessage id="transportadoraAbm.campos_requeridos" defaultMessage="* campos requeridos" /></div>
                      </h4>
                      <div className="row">
                        {/* Transportadora */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="nombre">
                              <FormattedMessage id="transportadoraAbm.datos_generales.transportadora" defaultMessage="Transportadora *:" />
                            </label>
                            <div className="col-md-8">
                              {this.props.action === 'VIEW' ? (
                                <div className="form-control-static col-form-label form-value">{formData.nombre}</div>
                              ) : (
                                <div>
                                  <input type="text" className="form-control" id="nombre" name="nombre" placeholder={this.props.intl.formatMessage({ id: 'transportadoraAbm.datos_generales.transportadora.placeholder', defaultMessage: 'Transportadora' })} value={formData.nombre} onChange={this.handleInputFormChange} />
                                  <div className="help-block text-danger field-message" hidden={validationState.formData.nombre.pristine || validationState.formData.nombre.valid}>{validationState.formData.nombre.message}</div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* Centro de Costo */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="centro_costo_nombre">
                              <FormattedMessage id="transportadoraAbm.datos_generales.centro_costo" defaultMessage="Centro de Costo:" />
                            </label>
                            <div className="col-md-8">
                              {this.props.action === 'VIEW' ? (
                                <div className="form-control-static col-form-label form-value">
                                  {formData.centro_costo && formData.centro_costo.nombre ? formData.centro_costo.nombre : '-'}
                                </div>
                              ) : (
                                <select
                                  className="form-control"
                                  id="centro_costo"
                                  name="centro_costo"
                                  value={formData.centro_costo && formData.centro_costo.id ? formData.centro_costo.id : ''}
                                  onChange={e => {
                                    const selectedId = e.target.value;
                                    const selectedCentro = this.state.centrosCostos.find(c => String(c.id) === selectedId);
                                    let formDataCopy = JSON.parse(JSON.stringify(formData));
                                    formDataCopy.centro_costo = selectedCentro || null;
                                    this.setState({ formData: formDataCopy });
                                  }}
                                >
                                  <option value="">- Seleccione -</option>
                                  {this.state.centrosCostos.map(c => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                  ))}
                                </select>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Activa */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="activa">
                              <FormattedMessage id="transportadoraAbm.datos_generales.activa" defaultMessage="Activa:" />
                            </label>
                            <div className="col-md-8 d-flex align-items-center">
                              <Switch
                                onChange={() => {
                                  if (this.props.action !== 'VIEW') {
                                    let formDataCopy = JSON.parse(JSON.stringify(formData));
                                    formDataCopy.activa = !formData.activa;
                                    this.setState({ formData: formDataCopy });
                                  }
                                }}
                                checked={formData.activa ? true : false}
                                id="activa"
                                name="activa"
                                disabled={this.props.action === 'VIEW'}
                                offColor="#FF4961"
                                onColor="#28D094"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <div className="text-cd text-right">
                        {this.props.action !== 'VIEW' && (
                          <button type="submit" className="btn btn-primary mr-1" disabled={!validationState.form.valid} >
                            <i className="fa fa-check-circle"></i><FormattedMessage id="transportadoraAbm.button.guardar" defaultMessage=" Guardar" />
                          </button>
                        )}
                        <button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
                          <i className="fa fa-times-circle"></i> {this.props.action === 'VIEW' ? this.props.intl.formatMessage({ id: 'transportadoraAbm.button.volver', defaultMessage: 'Volver' }) : this.props.intl.formatMessage({ id: 'transportadoraAbm.button.cancelar', defaultMessage: 'Cancelar' })}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default injectIntl(TransportadorasAbm);